"use client";

import { useDomainName } from "@context/DomainContext";
import { useTranslations } from "next-intl";

export default function useDomainBasedTranslations(base: string) {
  const domainName = useDomainName();
  const baseT = useTranslations(`${base}`);
  const override = useTranslations(`${base}.${domainName}`);

  return (key: string, values?: Record<string, string | number>) =>
    override.has(key) ? override(key, values) : baseT(key, values);
}

export type DomainBasedTranslations = ReturnType<
  typeof useDomainBasedTranslations
>;
